import { render, staticRenderFns } from "./project_visibility_icon.vue.js?vue&type=template&id=4bc73c66&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_visibility_icon.vue?vue&type=template&id=4bc73c66&vue3"
import script from "./project_visibility_icon.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_visibility_icon.vue?vue&type=script&lang=js&vue3"
export * from "./project_visibility_icon.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project_visibility_icon.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports